<script setup>
import { useI18n } from 'vue-i18n'
import { useCurrency } from '@/composables/useCurrency.js'

const { t } = useI18n()
const { formatMoney } = useCurrency()

defineProps({ earnings: { type: Object, required: true } })
</script>

<template>
  <div class="earnings-card">
    <h3 class="earnings-card__title">
      {{ t('driver_portal.earnings.title') }}
    </h3>
    <dl class="earnings-card__grid">
      <div class="earnings-card__stat">
        <dt class="earnings-card__label">{{ t('driver_portal.earnings.today') }}</dt>
        <dd class="earnings-card__value fw-value tabular-nums">
          {{ formatMoney(earnings.paid_today_cents) }}
        </dd>
      </div>
      <div class="earnings-card__stat">
        <dt class="earnings-card__label">{{ t('driver_portal.earnings.this_week') }}</dt>
        <dd class="earnings-card__value fw-value tabular-nums">
          {{ formatMoney(earnings.paid_week_cents) }}
        </dd>
      </div>
      <div class="earnings-card__stat earnings-card__stat--unpaid">
        <dt class="earnings-card__label">{{ t('driver_portal.earnings.unpaid') }}</dt>
        <dd class="earnings-card__value earnings-card__value--warn fw-value tabular-nums">
          {{ formatMoney(earnings.unpaid_cents) }}
          <span v-if="earnings.unpaid_count > 0" class="earnings-card__count">
            × {{ earnings.unpaid_count }}
          </span>
        </dd>
      </div>
    </dl>
  </div>
</template>

<style scoped>
.earnings-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 0.75rem;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
}
.earnings-card__title {
  margin: 0 0 0.75rem;
  font-size: 0.8125rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted);
}
.earnings-card__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin: 0;
}
.earnings-card__stat { text-align: center; }
.earnings-card__label {
  display: block;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted);
  margin-bottom: 0.25rem;
}
.earnings-card__value {
  display: block;
  font-size: 1rem;
  color: var(--ink);
  margin: 0;
}
.earnings-card__value--warn { color: var(--warn); }
.earnings-card__count {
  font-size: 0.75rem;
  color: var(--muted);
  margin-left: 0.15rem;
}
</style>
